<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Header
      :showGoBack="true"
      :title="'Select language'"
    />
    <main
      class="scrollable container"
      :style="{paddingTop: '10px'}"
    >
      <ul>
        <li
          :key="e"
          v-for="(e, index) in languages"
          class="clickable row-center-space-between"
          :style="{marginBottom: index === languages.length - 1 ? '0' : '4px'}"
          @click="setLanguage(e)"
        >
          <span
            class="t16"
            :style="{
              color:
                selectedLanguage === e
                  ? 'var(--main-color)'
                  : 'var(--main-dark)',
            }"
            >{{ e }}</span
          >
          <div
            v-if="selectedLanguage === e"
            :style="{
              width: '20px',
              height: '1px',
              backgroundColor: 'var(--main-color)',
            }"
          ></div>
        </li>
      </ul>
      <!-- <span>{{ selectedLanguage }}</span> -->
    </main>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import {useOpacity} from '@/hooks';
import {Header} from '@/components';

import {computed} from 'vue';
import {useStore} from 'vuex';

const store = useStore();

const selectedLanguage = computed(() => store.getters['language/language']);

const opacity = useOpacity();

const languages = ['English', 'Spanish'];

const setLanguage = (language) => {
  store.dispatch('language/setLanguage', language);
};
</script>
